// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"wrapper-3WukU","title":"title-3qtHh","text":"text-1z3J0"};